import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Paper from '@material-ui/core/Paper';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import { loadTableData, receivedVoucherModule } from './ReceivedVoucherDucks';
import { receivedVoucherColumn } from './ReceivedVoucherColumn';
import { useDispatch, useSelector } from 'react-redux';
import './ReceivedVoucherTranslation';
import useSimpleModal from '../../components/_hooks/useSimpleModal';
import ReceivedVoucherInfoModal from './Modal/ReceivedVoucherInfoModal';

export default function ReceivedVoucherPage() {
  const { t, i18n } = useTranslation();
  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('breadcrumbs_receivedVouchers') }
  ];
  const { tableData,   loadingTable } = useSelector(
    state => state[receivedVoucherModule]
  );
  const dispatch = useDispatch();
  const { nextPage } = useTableFilter(
    filter => dispatch(loadTableData(filter)),
    {
      pageNumber: 1,
      pageSize: 10
    },
    ''
  );
  const receivedVoucherModal = useSimpleModal();

  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <h3>{t('receivedVoucherPage_title')}</h3>
        <StaticTablePagination
          columns={receivedVoucherColumn({
            t,
            lang: i18n.language
          })}
          data={tableData.content}
          sortable={false}
          loading={loadingTable}
          onClickRow={({ row }) => receivedVoucherModal.open({ row })}
          totalElements={tableData.totalElements}
          onClickLoadMore={() => nextPage()}
        />
      </Paper>

      {receivedVoucherModal.isOpen && (
        <ReceivedVoucherInfoModal
          {...receivedVoucherModal.data}
          open={receivedVoucherModal.isOpen}
          onClose={receivedVoucherModal.close}
          lang={i18n.language}
        />
      )}
    </>
  );
}
